<template>
  <div class="section-buffer">
    <Section>
      <div class="section-header" slot="header">
        <h1 class="title">Buffer</h1>
      </div>
      <div class="section-body">
        <div class="row">
          <div class="col-12 col-md-12 col-lg-6 graph-buffer-section">
            <LineChart
              v-if="bufferData && bufferData.noBufferDurationGraph && graphData"
              :colors="['#24D09C']"
              :series="graphData"
              :categories="null"
              :xAxistype="'date'"
            />
            <EmptyMessage v-if="isDataNotFound()">
              ไม่พบข้อมูลในช่วงเวลาดังกล่าว
            </EmptyMessage>
            <EmptyMessage v-if="!isLoading && isError">
              <h3>พบข้อผิดพลาดระหว่างโหลดข้อมูล</h3>
              <p>
                โปรดรอซักครู่เพื่อโหลดข้อมูลใหม่ หรือติดต่อ
                <a
                  :href="`mailto:support@byteark.com`"
                  target="_top"
                >support@byteark.com</a>
              </p>
              <span slot="code" class="code">error code : {{error.status || 'not found' }} </span>
            </EmptyMessage>
            <div v-if="isLoading" class="d-flex justify-content-center">
              <div class="spinner-border" role="status" />
            </div>
          </div>
          <div class="col-6 col-md-6 col-lg-3 no-buffer-section">
            <h5 class="text-center header-label">No-Buffer Plays</h5>
            <GuageChart
              v-if="bufferData && bufferData.averageBufferDuration && !isError"
              :series="noBufferPercentArray"
              :label="guaueLabel"
              :differentPercentage="bufferData.noBufferDifferencePercentage"
            />
            <EmptyMessage
              v-if="!isLoading && bufferData && !bufferData.averageBufferDuration && !isError"
            >ไม่พบข้อมูลในช่วงเวลาดังกล่าว
            </EmptyMessage>
            <div v-if="isLoading" class="d-flex justify-content-center">
              <div class="spinner-border" role="status" />
            </div>
          </div>
          <div class="col-6 col-md-6 col-lg-3 avg-buffer-section">
            <h5 class="text-center header-label">Average Buffer Duration</h5>
            <NumberCircle
              v-if="bufferData && bufferData.averageBufferDuration && !isError"
              :duration="bufferData.averageBufferDuration"
            />
            <EmptyMessage
              v-if="!isLoading && bufferData && !bufferData.averageBufferDuration && !isError"
            >ไม่พบข้อมูลในช่วงเวลาดังกล่าว</EmptyMessage>
            <div v-if="isLoading" class="d-flex justify-content-center">
              <div class="spinner-border" role="status" />
            </div>
          </div>
        </div>
      </div>
    </Section>
  </div>
</template>

<script>
import _ from 'lodash';
import generateLink from '@/utils/generateLink';
import LineChart from '@/charts/LineChart.vue';
import GuageChart from '@/charts/GuageChart.vue';
import Section from '@/components/Section.vue';
import NumberCircle from '@/components/NumberCircle.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';

export default {
  mixins: [generateLink],
  props: ['bufferData', 'isLoading', 'isError', 'error'],
  components: {
    LineChart,
    GuageChart,
    Section,
    NumberCircle,
    EmptyMessage,
  },
  created() {
    // this.createChart();
  },
  data() {
    return {
      graphData: null,
      bufferGraph: [],
      noBufferPercentArray: [],
    };
  },
  watch: {
    bufferData() {
      this.createChart();
      this.updateBufferPercentage();
    },
    '$route.query': {
      handler() {
        // const filter = this.generateQuery(this.$route.query);
      },
    },
  },
  computed: {
    guaueLabel() {
      const filter = this.generateQuery(this.$route.query);
      let returnText = '';
      switch (filter.range) {
        case 'last24hours':
          returnText = 'Average Last 24 Hours';
          break;
        case 'last7days':
          returnText = 'Average Last 7 Days';
          break;
        case 'last30days':
          returnText = 'Average Last 24 Days';
          break;
        default:
          returnText = 'Average Last 24 Hours';
          break;
      }
      return returnText;
    },
  },
  methods: {
    async createChart() {
      if (this.bufferData) {
        const result = _.map(
          this.bufferData.noBufferDurationGraph,
          (data, index) => ({
            x: data.date,
            y: data.noBufferPercentage,
            i: index,
          }),
        );
        this.graphData = [
          {
            name: '',
            data: await result,
          },
        ];
      }
    },
    async updateBufferPercentage() {
      this.noBufferPercentArray = [];
      if (this.bufferData.noBufferPercentage) {
        this.noBufferPercentArray.push(
          this.bufferData.noBufferPercentage.toFixed(2),
        );
      }
    },
    isDataNotFound() {
      return !this.isLoading
        && this.bufferData
        && !this.bufferData.noBufferDurationGraph
        && !this.isError;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.section-buffer {
  .section {
    min-height: 350px;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  .no-buffer-section {
    margin-top: $spacer * 4;
  }
  .avg-buffer-section {
    margin-top: $spacer * 4;
  }
}

@media (min-width: 1301px) and (max-width: 1600px) {
  .no-buffer-section {
    margin-top: $spacer * 4;
  }
  .avg-buffer-section {
    margin-top: $spacer * 4;
  }
}

.no-buffer-section {
  margin-top: $spacer * 2;
}

.avg-buffer-section {
  margin-top: $spacer * 2;
}
.graph-buffer-section {
  margin-top: $spacer * 0.75;
}
</style>
